module.exports = __webpack_public_path__ + "static/img/Email.a043304a.svg";